import React from 'react';
import PropTypes from 'prop-types';
import Colors from 'common/constants/colors';
import styles from './index.css';

let id = '';

export default class StripeDefs extends React.Component {
  static propTypes = {
    id: PropTypes.string,
  };

  static defaultProps = {
    id: '',
  };

  constructor(props) {
    super(props);

    this.setId(this.props);
  }

  static getMaskID() {
    return `stripeMask-${id}`;
  }

  static getPatternID() {
    return `stripePattern-${id}`;
  }

  setId(props) {
    id = props.id || '';
  }

  render() {
    return (
      <defs className={styles.StripeDefs}>
        <pattern
          height={4}
          id={StripeDefs.getPatternID()}
          patternTransform={'rotate(135)'}
          patternUnits={'userSpaceOnUse'}
          width={6}>
          <rect fill={Colors.white} height={4} width={2} />
        </pattern>
        <mask id={StripeDefs.getMaskID()}>
          <rect
            fill={`url(#${StripeDefs.getPatternID()})`}
            height={'100%'}
            width={'100%'}
          />
        </mask>
      </defs>
    );
  }
}
